"use client"

import type { HubClientProps } from "./hub-shared"
import CategoryHub from "./hub-category"
import BrandHub from "./hub-brand"
import GuideHub from "./hub-guide"
import ComparisonHub from "./hub-comparison"
import FeatureHub from "./hub-feature"
import SpecialtyHub from "./hub-specialty"

export default function HubClient(props: HubClientProps) {
  switch (props.hub.hub_type) {
    case 'category':
      return <CategoryHub {...props} />
    case 'brand':
      return <BrandHub {...props} />
    case 'guide':
      return <GuideHub {...props} />
    case 'comparison':
      return <ComparisonHub {...props} />
    case 'feature':
      return <FeatureHub {...props} />
    case 'specialty':
      return <SpecialtyHub {...props} />
    default:
      return <CategoryHub {...props} />
  }
}
